<template>
<div>
  <div v-if="loading">
    <Loading/>
  </div>
  <div v-if="!loading">
  <v-row justify="center">
    <v-col md="6">
      <v-card v-if="userCard.data" class="info--text ml-4 main" elevation="16">
        <v-card-title class="primary--text">Card details</v-card-title>
        <v-card-text>
          <v-row no-gutters style="color: #757575">
            <v-col md="3" class="text-center">
              <span>Brand</span> <br/>
              <span style="font-size: 16px;">{{ userCard.data.card.brand }}</span>
            </v-col>
            <v-col class="text-center">
              <span>cardNo</span> <br/>
              <span style="font-size: 16px;"> ---- ---- ---- {{ userCard.data.card.last4 }}</span>
            </v-col>
            <v-col md="2" class="text-center">
              <span>exp</span> <br/>
              <span style="font-size: 16px;">{{ userCard.data.card.exp_month + '/' + userCard.data.card.exp_year }}</span> 
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <br v-if="!userCard.data"/>
      <v-container>
        <v-row>
          <v-col>
            <h4> {{ userCard.data ? 'Update card ?' : 'Add card ?' }} </h4>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <stripe-element-card
              ref="elementRef"
              :pk="publishableKey"
              @token="tokenCreated"
              hidePostalCode
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col align="end">
            <v-btn
            :disabled="disabled"
            block
            rounded
            height="50" 
            @click="submit" 
            class="primary"
            > {{ userCard.data ? 'Update card' : 'Add card' }} </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
  </div>
</div>
</template>

<script>
import { StripeElementCard } from '@vue-stripe/vue-stripe';
import Loading from "@/components/Loading";

export default {
  name: "UserCard",
  components: {
    StripeElementCard,
    Loading
  },
  data () {
    return {
      errors: [],
      fname: '',
      lname: '',
      disabled: false,
      token: null,
      publishableKey: process.env.VUE_APP_PUB_KEY,
      loading: false,
    }
  },
  computed: {
    getUser(){
      return this.$store.getters['auth/getUser'];
    },
    userCard(){
      return this.$store.getters['auth/getUserCard'];
    }
  },
  methods:{
    async submit() {
      this.disabled = true;
      this.$refs.elementRef.submit();
    },
    async tokenCreated (token) {
      if(token){
        this.loading = true;
        await this.$store.dispatch('auth/registerUserCard', {
          id: this.getUser.id,
          token: token.id
        }); 
      }
    }
  },
  async mounted() {
    if(this.getUser.paymentMethod){
      this.$store.dispatch('auth/fetchUserCard', {
        stripeId: this.getUser.stripeId,
        paymentMethod: this.getUser.paymentMethod
      })
    }
  }
}
</script>

<style scoped>

</style>